import { z } from 'zod';

/**
 * Feedback form validation schema.
 */
export const feedbackSchema = z.object({
  email: z.string().email('Please enter a valid email address'),
  message: z.string().min(10, 'Please provide at least 10 characters'),
});

export type FeedbackFormValues = z.infer<typeof feedbackSchema>;

export const feedbackDefaultValues: FeedbackFormValues = {
  email: '',
  message: '',
};

/**
 * User mode for feedback tracking.
 * - 'personal': Free tier (not on trial)
 * - 'trial': Active trial period
 * - 'pro': Paid Pro subscription
 */
export type FeedbackUserMode = 'personal' | 'trial' | 'pro';

/**
 * Feedback submission request/response types.
 */
export type SubmitFeedbackRequest = {
  email: string;
  message: string;
  timestamp: string;
  /**
   * The real app version (e.g. "1.4.15") when known; legacy 'desktop' /
   * 'web' markers when it can't be resolved. Platform/arch travel inside
   * the message footer (see HelpFeedbackDialog) so the backend contract
   * needs no new fields.
   */
  appVersion?: string;
  /** User's current license mode */
  mode?: FeedbackUserMode;
  /** User ID if logged in (null if not logged in) */
  userId?: string | null;
};

export type SubmitFeedbackResult = {
  success: boolean;
  error?: string;
};
